import { BlockStoreList } from "../parts/store";

export class DynamicBlock {
    constructor(moduleName = 'blockInstance', className = 'BlockInstance', element:HTMLElement) {
        if(className === undefined || className === 'Block' || !BlockStoreList.includes(moduleName)) return;
        import(`../blocks/${moduleName}.ts`).then((blockConstructor) => {
            return new blockConstructor[className](className, element);
        })
    }
}
